// extracted by mini-css-extract-plugin
export var divider = "_s6-0";
export var systemMessage = "_s6-1";
export var systemMessageWrapper = "_s6-2";